import {
  retrieveMenuItemsByTypeApi,
  retrieveAllMenuItemsByTypeApi,
  createMenuItemApi,
  updateMenuItemApi,
  deleteMenuItemApi,
  deleteMultipleMenuItemsApi,
  restoreMenuItemApi,
  retrieveAllMenuItemTypesApi
} from '../../../components/api/MenuItemApiService';

export const fetchMenuItemsByType = async (type) => {
  try {
    const response = await retrieveMenuItemsByTypeApi(type);
    return response.data.map(item => ({
      id: item.id,
      value: item.value,
      label: item.label,
      recordStatus: item.recordStatus
    }));
  } catch (error) {
    console.error(`Error fetching menu items for type ${type}:`, error);
    throw error;
  }
};

export const fetchAllMenuItemsByType = async (type) => {
  try {
    const response = await retrieveAllMenuItemsByTypeApi(type);
    return response.data.map(item => ({
      id: item.id,
      value: item.value,
      label: item.label,
      recordStatus: item.recordStatus
    }));
  } catch (error) {
    console.error(`Error fetching all menu items for type ${type}:`, error);
    throw error;
  }
};

export const createMenuItem = async (menuItem) => {
  try {
    const response = await createMenuItemApi(menuItem);
    return response.data;
  } catch (error) {
    console.error('Error creating menu item:', error);
    throw error;
  }
};

export const updateMenuItem = async (id, menuItem) => {
  try {
    const response = await updateMenuItemApi(id, menuItem);
    return response.data;
  } catch (error) {
    console.error(`Error updating menu item ${id}:`, error);
    throw error;
  }
};

export const softDeleteMenuItem = async (id) => {
  try {
    const response = await deleteMenuItemApi(id);
    return response.data;
  } catch (error) {
    console.error(`Error deleting menu item ${id}:`, error);
    throw error;
  }
};

export const softDeleteMultipleMenuItems = async (idList) => {
  try {
    const response = await deleteMultipleMenuItemsApi(idList);
    return response.data;
  } catch (error) {
    console.error('Error deleting multiple menu items:', error);
    throw error;
  }
};

export const restoreMenuItem = async (id) => {
  try {
    const response = await restoreMenuItemApi(id);
    return response.data;
  } catch (error) {
    console.error(`Error restoring menu item ${id}:`, error);
    throw error;
  }
};

export const fetchAllMenuItemTypes = async () => {
  try {
    const response = await retrieveAllMenuItemTypesApi();
    return response.data;
  } catch (error) {
    console.error('Error fetching menu item types:', error);
    throw error;
  }
};